(() => {
  function initSolariiGuide(host) {
    if (!host || host.dataset.solariiGuideReady === "true") return;
    const templateId = host.getAttribute("data-solarii-template");
    const template = templateId ? document.getElementById(templateId) : null;
    if (!template) return;

    host.dataset.solariiGuideReady = "true";
    const root = host.attachShadow({ mode: "open" });
    root.appendChild(template.content.cloneNode(true));
    const configElement = root.querySelector("[data-guide-config]");
    let guideConfig = {};
    if (configElement) {
      try {
        guideConfig = JSON.parse(configElement.textContent || "{}");
      } catch (error) {
        guideConfig = {};
      }
    }

    const titles = Array.isArray(guideConfig.titles) && guideConfig.titles.length
      ? guideConfig.titles
      : [
      "Brand Story",
      "Source Factory",
      "Our Advantages",
      "Metal Materials",
      "Stone Materials",
      "Our Promise & Customer Stories",
      "Real Moments & Answers"
    ];

    const guide = root.querySelector(".guide");
    const cover = root.querySelector("#guideCover");
    const content = root.querySelector("#guideContent");
    const progressText = root.querySelector("#progressText");
    const nextLabel = root.querySelector("#nextLabel");
    const contentSections = root.querySelectorAll(".chapter-content");
    const placeholder = root.querySelector("[data-content='placeholder']");
    const placeholderTitle = root.querySelector("#placeholderTitle");
    let currentIndex = 0;

    function twoDigit(number) {
      return String(number).padStart(2, "0");
    }

    root.querySelectorAll("[data-circle-text]").forEach((element) => {
      const text = element.dataset.circleText || "";
      const characters = Array.from(text);
      element.innerHTML = characters.map((char, index) => {
        const angle = (360 / characters.length) * index;
        const value = char === " " ? "&nbsp;" : char;
        return `<span style="transform:rotate(${angle}deg)">${value}</span>`;
      }).join("");
    });

    const featureTabsData = Array.isArray(guideConfig.featureTabs) && guideConfig.featureTabs.length
      ? guideConfig.featureTabs
      : [
      {
        title: "Lifetime Care for Every Solarii Ring",
        descOne: "Every Solarii ring is made to be worn, loved, and remembered. That is why we stand behind our craftsmanship with lifetime warranty support.",
        descTwo: "From material quality to handcrafted details, our goal is to help your ring feel protected long after it arrives.",
        cta: "Lifetime Warranty Support",
        glow: "rgba(154, 0, 75, .72)",
        glow2: "rgba(172, 190, 38, .25)",
        images: [
          "//solariijewelry.com/cdn/shop/t/97/assets/promise-lifetime-square-1.png?v=14963",
          "//solariijewelry.com/cdn/shop/t/97/assets/promise-lifetime-square-2.png?v=14963",
          "//solariijewelry.com/cdn/shop/t/97/assets/promise-lifetime-wide.png?v=14963"
        ]
      },
      {
        title: "Aftercare That Keeps Your Ring Beautiful",
        descOne: "A ring should feel beautiful and comfortable over time. Solarii offers free replating and free resizing support to help your piece stay wearable and well cared for.",
        descTwo: "Whether your ring needs a refreshed finish or a better fit, our aftercare support helps extend the life and comfort of your jewelry.",
        cta: "Free Replating & Free Resizing",
        glow: "rgba(83, 112, 0, .68)",
        glow2: "rgba(17, 60, 14, .38)",
        images: [
          "//solariijewelry.com/cdn/shop/t/97/assets/promise-resizing-square-1.png?v=14963",
          "//solariijewelry.com/cdn/shop/t/97/assets/promise-resizing-square-2.png?v=14963",
          "//solariijewelry.com/cdn/shop/t/97/assets/promise-resizing-wide.png?v=14963"
        ]
      },
      {
        title: "Designed With You, From the First Idea",
        descOne: "Your custom ring can begin with a photo, sketch, inspiration, or simple idea. Our design team works with you online to refine the details before production begins.",
        descTwo: "From stone shape to setting style, we help turn your idea into a ring that feels personal, balanced, and made for your story.",
        cta: "Online Custom Design Support",
        glow: "rgba(29, 53, 120, .7)",
        glow2: "rgba(90, 111, 210, .25)",
        images: [
          "//solariijewelry.com/cdn/shop/t/97/assets/promise-design-square-1.png?v=14963",
          "//solariijewelry.com/cdn/shop/t/97/assets/promise-design-square-2.png?v=14963",
          "//solariijewelry.com/cdn/shop/t/97/assets/promise-design-wide.png?v=14963"
        ]
      }
    ];

    root.querySelectorAll("[data-sol-feature-tabs]").forEach((section) => {
      const nav = section.querySelector(".sol-feature-tabs__nav");
      const tabs = [...section.querySelectorAll(".sol-feature-tabs__tab")];
      const title = section.querySelector("[data-feature-title]");
      const descOne = section.querySelector("[data-feature-desc-one]");
      const descTwo = section.querySelector("[data-feature-desc-two]");
      const ctaText = section.querySelector("[data-feature-cta-text]");
      const images = [
        section.querySelector("[data-feature-img-one]"),
        section.querySelector("[data-feature-img-two]"),
        section.querySelector("[data-feature-img-three]")
      ];
      let featureScrollTimer = null;

      function scrollFeatureNav(index) {
        if (!nav || window.innerWidth > 900) return;

        const target = tabs[index];
        if (!target) return;

        window.requestAnimationFrame(() => {
          let left = target.offsetLeft - (nav.clientWidth - target.offsetWidth) / 2;

          if (index === 0) {
            left = 0;
          } else if (index === tabs.length - 1) {
            left = nav.scrollWidth - nav.clientWidth;
          }

          nav.scrollTo({
            left: Math.max(0, left),
            behavior: "smooth"
          });
        });
      }

      function syncFeatureContent(item) {
        title.textContent = item.title;
        descOne.textContent = item.descOne;
        descTwo.textContent = item.descTwo;
        ctaText.textContent = item.cta;
        section.style.setProperty("--glow", item.glow);
        section.style.setProperty("--glow-2", item.glow2);

        images.forEach((img, imgIndex) => {
          img.src = item.images[imgIndex];
        });
      }

      function setActiveFeature(index, force = false) {
        const item = featureTabsData[index];
        if (!item) return;

        if (tabs[index]?.classList.contains("is-active") && !force) {
          scrollFeatureNav(index);
          return;
        }

        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle("is-active", isActive);
          tab.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        if (featureScrollTimer) {
          window.clearTimeout(featureScrollTimer);
        }
        featureScrollTimer = window.setTimeout(() => {
          scrollFeatureNav(index);
          featureScrollTimer = null;
        }, 420);

        if (force) {
          syncFeatureContent(item);
          scrollFeatureNav(index);
          return;
        }

        section.classList.add("is-changing");

        window.setTimeout(() => {
          syncFeatureContent(item);
          section.classList.remove("is-changing");
        }, 230);
      }

      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          setActiveFeature(Number(tab.dataset.featureIndex));
        });
      });

      const initialFeatureIndex = Math.max(0, tabs.findIndex((tab) => tab.classList.contains("is-active")));
      setActiveFeature(initialFeatureIndex, true);
    });

    root.querySelectorAll("[data-sol-moments]").forEach((section) => {
      const track = section.querySelector("[data-sol-moments-track]");
      const columns = [...section.querySelectorAll(".sol-moments-column")];
      const modal = section.querySelector(".sol-moments-modal");
      const modalDialog = section.querySelector(".sol-moments-modal-dialog");
      const modalMedia = section.querySelector(".sol-moments-modal-media");
      const modalClose = section.querySelector(".sol-moments-modal-close");

      if (track && !track.dataset.loopReady) {
        columns.forEach((column) => {
          const clone = column.cloneNode(true);
          clone.dataset.loopClone = "true";
          clone.setAttribute("aria-hidden", "true");
          clone.querySelectorAll("button").forEach((button) => {
            button.tabIndex = -1;
          });
          track.appendChild(clone);
        });
        track.dataset.loopReady = "true";
      }

      if (modal && modal.parentNode !== root) {
        root.appendChild(modal);
      }

      const closeModal = () => {
        if (!modal || !modalMedia) return;
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        modalMedia.innerHTML = "";
        document.body.style.overflow = "";
      };

      track?.addEventListener("click", (event) => {
        const card = event.target.closest(".sol-moments-card");
        if (!card || !track.contains(card) || !modal || !modalMedia) return;
        const template = card.querySelector(".sol-moments-template");
        if (template && template.innerHTML.trim()) {
          modalMedia.innerHTML = template.innerHTML.trim();
          const video = modalMedia.querySelector("video");
          if (video) {
            video.play?.().catch(() => {});
          }
        } else {
          const src = card.dataset.momentMedia || card.querySelector("img")?.src || "";
          if (!src) return;
          modalMedia.innerHTML = `<img src="${src}" alt="">`;
        }
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
      });

      modalClose?.addEventListener("click", closeModal);
      modal?.addEventListener("click", (event) => {
        if (event.target === modal) closeModal();
      });
      modalDialog?.addEventListener("click", (event) => event.stopPropagation());
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") closeModal();
      });

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

      const updateMomentsParallax = () => {
        if (!section.closest(".chapter-content.is-active") || window.innerWidth <= 900) {
          columns.forEach((column) => {
            column.style.transform = "";
          });
          return;
        }

        const rect = section.getBoundingClientRect();
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        const travel = Math.max(1, rect.height - viewport * .28);
        const progress = clamp((-rect.top) / travel, 0, 1);

        columns.forEach((column) => {
          const isEven = column.classList.contains("sol-moments-column--even");
          const y = (isEven ? -18 : -10.8) * progress;
          column.style.transform = `translateY(${y.toFixed(4)}%)`;
        });
      };

      let parallaxFrame = null;
      const requestMomentsUpdate = () => {
        if (parallaxFrame) return;
        parallaxFrame = window.requestAnimationFrame(() => {
          parallaxFrame = null;
          updateMomentsParallax();
        });
      };

      let mobileFrame = null;
      let mobilePaused = false;
      let lastTime = 0;

      const getMobileLoopWidth = () => {
        if (!track) return 0;
        const firstColumn = track.querySelector(".sol-moments-column:not([data-loop-clone])");
        const firstClone = track.querySelector(".sol-moments-column[data-loop-clone]");
        if (!firstColumn || !firstClone) return 0;
        return firstClone.offsetLeft - firstColumn.offsetLeft;
      };

      const normalizeMobileLoop = () => {
        if (!track || window.innerWidth > 900) return;
        const loopWidth = getMobileLoopWidth();
        if (!loopWidth) return;

        if (track.scrollLeft >= loopWidth) {
          track.scrollLeft -= loopWidth;
        }
      };

      let normalizeFrame = null;
      const requestMobileNormalize = () => {
        if (normalizeFrame) return;
        normalizeFrame = window.requestAnimationFrame(() => {
          normalizeFrame = null;
          if (!mobilePaused) normalizeMobileLoop();
        });
      };

      const stopMobileAutoScroll = () => {
        if (mobileFrame) {
          window.cancelAnimationFrame(mobileFrame);
          mobileFrame = null;
        }
      };

      const startMobileAutoScroll = () => {
        if (!track || mobileFrame) return;

        const step = (time) => {
          if (window.innerWidth > 900) {
            stopMobileAutoScroll();
            return;
          }

          if (!lastTime) lastTime = time;
          const delta = time - lastTime;
          lastTime = time;

          if (!section.closest(".chapter-content.is-active")) {
            lastTime = 0;
            mobileFrame = window.requestAnimationFrame(step);
            return;
          }

          if (!mobilePaused && track.scrollWidth > track.clientWidth) {
            track.scrollLeft += delta * .095;
            normalizeMobileLoop();
          }

          mobileFrame = window.requestAnimationFrame(step);
        };

        mobileFrame = window.requestAnimationFrame(step);
      };

      track?.addEventListener("touchstart", () => { mobilePaused = true; }, { passive: true });
      track?.addEventListener("touchend", () => {
        mobilePaused = false;
        lastTime = 0;
        normalizeMobileLoop();
      }, { passive: true });
      track?.addEventListener("pointerdown", () => { mobilePaused = true; });
      track?.addEventListener("pointerup", () => {
        mobilePaused = false;
        lastTime = 0;
        normalizeMobileLoop();
      });
      track?.addEventListener("pointercancel", () => {
        mobilePaused = false;
        lastTime = 0;
        normalizeMobileLoop();
      });
      track?.addEventListener("scroll", requestMobileNormalize, { passive: true });

      window.addEventListener("scroll", requestMomentsUpdate, { passive: true });
      window.addEventListener("resize", () => {
        lastTime = 0;
        requestMomentsUpdate();
        if (window.innerWidth <= 900) startMobileAutoScroll();
        if (window.innerWidth > 900) stopMobileAutoScroll();
      });
      window.addEventListener("solarii:chapter-render", () => {
        lastTime = 0;
        requestMomentsUpdate();
        if (window.innerWidth <= 900) startMobileAutoScroll();
      });

      if (window.innerWidth <= 900) startMobileAutoScroll();
      updateMomentsParallax();
    });

    (() => {
      const faqData = [
        {
          tag: "Material",
          question: "How do I start a custom ring?",
          answer: "Send us your inspiration photo, sketch, stone shape, metal choice, ring size, and any special details. Our team will review your idea and guide you through the next steps."
        },
        {
          tag: "Photo Design",
          question: "Can you make a ring from a photo?",
          answer: "Yes. You can send a reference photo, and we will help adjust the design into a custom ring that fits your preferred stone, metal, and style."
        },
        {
          tag: "Design Fee",
          question: "Do I need to pay for the design first?",
          answer: "No. We offer free custom design support before production, so you can confirm the main details before your ring is made."
        },
        {
          tag: "Options",
          question: "Can I choose the metal and stone?",
          answer: "Yes. You can choose solid K gold options, stone shape, stone size, and gemstone type, including lab-grown diamond or moissanite depending on the design."
        },
        {
          tag: "Timeline",
          question: "How long does a custom ring take to make?",
          answer: "Custom silver rings usually take about 7 business days to make. Solid K gold custom rings usually take about 15 business days before shipping."
        },
        {
          tag: "Preview",
          question: "Will I see the design before production?",
          answer: "Yes. We confirm the important design details with you before production begins, including stone, metal, size, and custom notes."
        },
        {
          tag: "Engraving",
          question: "Can I add engraving?",
          answer: "Yes. We offer free engraving for custom rings. You can send us the text you want before production starts."
        },
        {
          tag: "Shipping",
          question: "What shipping method do you use for custom orders?",
          answer: "Custom orders are shipped with secure tracked delivery. For U.S. orders, we can use UPS signature service when available for added delivery security."
        }
      ];

      const arrowSvg = `
        <span class="sol-float-question__arrow" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M8 12h8.2M13 7l5 5-5 5" />
          </svg>
        </span>
      `;

      const setTypingDots = (element) => {
        if (!element) return;
        element.innerHTML = '<span class="sol-typing"><span></span><span></span><span></span></span>';
      };

      const typeText = (element, text, tokenRef, speed = 11) => {
        if (!element) return;
        element.textContent = "";
        let index = 0;
        const tick = () => {
          if (tokenRef.cancelled) return;
          if (index < text.length) {
            element.textContent += text.charAt(index);
            index += 1;
            window.setTimeout(tick, speed);
          }
        };
        tick();
      };

      root.querySelectorAll("[data-sol-floating-faq]").forEach((section) => {
        if (section.dataset.faqReady === "true") return;
        section.dataset.faqReady = "true";

        const floatingMap = section.querySelector("[data-faq-map]");
        const mobileQuestions = section.querySelector("[data-faq-mobile-questions]");
        const mobileLabel = section.querySelector("[data-faq-mobile-label]");
        const mobileTitle = section.querySelector("[data-faq-mobile-title]");
        const mobileText = section.querySelector("[data-faq-mobile-text]");

        if (!floatingMap || !mobileQuestions) return;

        let desktopTypingRefs = [];
        let mobileTypingRef = { cancelled: false };

        const closeAllDesktop = () => {
          section.querySelectorAll(".sol-faq-item").forEach((item) => {
            item.classList.remove("is-active");
          });
        };

        const openMobile = (index, clickedButton) => {
          const item = faqData[index];
          if (!item) return;

          section.querySelectorAll(".sol-mobile-question").forEach((button) => {
            button.classList.toggle("is-active", Number(button.dataset.index) === index);
          });

          if (clickedButton && clickedButton.classList.contains("sol-mobile-question")) {
            window.requestAnimationFrame(() => {
              const scroller = clickedButton.closest(".sol-mobile-questions");
              if (!scroller) return;
              const targetLeft = clickedButton.offsetLeft - (scroller.clientWidth - clickedButton.offsetWidth) / 2;
              scroller.scrollTo({ left: Math.max(0, targetLeft), behavior: "smooth" });
            });
          }

          mobileTypingRef.cancelled = true;
          mobileTypingRef = { cancelled: false };

          if (mobileLabel) mobileLabel.textContent = item.tag;
          if (mobileTitle) mobileTitle.textContent = item.question;
          setTypingDots(mobileText);

          window.setTimeout(() => {
            typeText(mobileText, item.answer, mobileTypingRef);
          }, 260);
        };

        const createDesktopItem = (item, index) => {
          const wrapper = document.createElement("div");
          const isDropUp = index >= 4;
          wrapper.className = `sol-faq-item q${index + 1}${isDropUp ? " is-drop-up" : ""}`;
          wrapper.dataset.index = index;

          const button = document.createElement("button");
          button.type = "button";
          button.className = "sol-float-question";
          button.innerHTML = `
            <span class="sol-float-question__tag">${item.tag}</span>
            <span class="sol-float-question__text">${item.question}</span>
            ${arrowSvg}
          `;

          const dropdown = document.createElement("div");
          dropdown.className = "sol-faq-dropdown";
          dropdown.innerHTML = `
            <div class="sol-faq-dropdown__head">
              <div class="sol-faq-dropdown__agent">
                <div class="sol-faq-dropdown__avatar">S</div>
                <div>
                  <strong>Solarii Support</strong>
                  <span>Custom Ring Guidance</span>
                </div>
              </div>
              <button class="sol-faq-dropdown__close" type="button" aria-label="Close">&times;</button>
            </div>
            <div class="sol-faq-dropdown__body">
              <p class="sol-faq-dropdown__label">${item.tag}</p>
              <div class="sol-faq-dropdown__question">${item.question}</div>
              <div class="sol-faq-dropdown__answer" data-desktop-answer="${index}"></div>
            </div>
          `;

          const answerElement = dropdown.querySelector(`[data-desktop-answer="${index}"]`);
          const closeBtn = dropdown.querySelector(".sol-faq-dropdown__close");

          const openDesktop = () => {
            const isSame = wrapper.classList.contains("is-active");
            closeAllDesktop();
            desktopTypingRefs.forEach(ref => ref.cancelled = true);
            desktopTypingRefs = [];

            if (isSame) return;

            wrapper.classList.add("is-active");
            setTypingDots(answerElement);
            const typingRef = { cancelled: false };
            desktopTypingRefs.push(typingRef);

            window.setTimeout(() => {
              typeText(answerElement, item.answer, typingRef);
            }, 260);
          };

          button.addEventListener("click", openDesktop);

          closeBtn.addEventListener("click", (event) => {
            event.stopPropagation();
            wrapper.classList.remove("is-active");
          });

          wrapper.appendChild(button);
          wrapper.appendChild(dropdown);
          return wrapper;
        };

        const createMobileQuestion = (item, index) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "sol-mobile-question";
          button.dataset.index = index;
          button.innerHTML = `
            <span class="sol-float-question__tag">${item.tag}</span>
            <span class="sol-float-question__text">${item.question}</span>
            ${arrowSvg}
          `;
          button.addEventListener("click", () => openMobile(index, button));
          return button;
        };

        faqData.forEach((item, index) => {
          floatingMap.appendChild(createDesktopItem(item, index));
          mobileQuestions.appendChild(createMobileQuestion(item, index));
        });

        const setupAreaHoverReveal = () => {
          const items = [...section.querySelectorAll(".sol-faq-item")];
          if (!items.length) return;

          let frame = null;
          let lastEvent = null;

          const resetItems = () => {
            items.forEach((item) => {
              if (!item.classList.contains("is-active")) {
                item.classList.remove("is-revealed");
              }
            });
          };

          const update = () => {
            frame = null;
            if (!lastEvent || window.innerWidth <= 900) return;

            let nearest = null;
            let nearestDistance = Infinity;

            items.forEach((item) => {
              const trigger = item.querySelector(".sol-float-question");
              if (!trigger) return;
              const rect = trigger.getBoundingClientRect();
              if (rect.width <= 0 || rect.height <= 0) return;

              const distance = Math.hypot(
                lastEvent.clientX - (rect.left + rect.width / 2),
                lastEvent.clientY - (rect.top + rect.height / 2)
              );

              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearest = item;
              }
            });

            items.forEach((item) => {
              if (!item.classList.contains("is-active")) {
                item.classList.toggle("is-revealed", item === nearest);
              }
            });
          };

          section.addEventListener("pointermove", (event) => {
            if (window.innerWidth <= 900) return;
            lastEvent = event;
            if (!frame) frame = window.requestAnimationFrame(update);
          }, { passive: true });

          section.addEventListener("pointerleave", resetItems);
        };

        root.addEventListener("click", (event) => {
          if (!section.contains(event.target)) return;
          const inDesktopItem = event.target.closest(".sol-faq-item");
          if (!inDesktopItem && window.innerWidth > 900) {
            closeAllDesktop();
          }
        });

        setupAreaHoverReveal();
        openMobile(0);
      });
    })();

    let thresholdFrame = null;

    function updateFloatingTopbar() {
      const shouldFloat = guide.classList.contains("is-content-open") && guide.getBoundingClientRect().top <= 0;
      guide.classList.toggle("is-topbar-floating", shouldFloat);
    }

    function getAnnouncementOffset() {
      const variable = window.innerWidth < 750 ? "--ANNOUNCEMENT-HEIGHT-MOBILE" : "--ANNOUNCEMENT-HEIGHT-DESKTOP";
      const value = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue(variable));
      return Number.isFinite(value) ? value : 0;
    }

    function getStickyHeaderOffset() {
      if (window.theme && typeof window.theme.readHeights === "function") {
        const heights = window.theme.readHeights();
        return heights && Number.isFinite(heights.stickyHeaderHeight) ? heights.stickyHeaderHeight : 0;
      }

      const value = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue("--header-height"));
      return Number.isFinite(value) ? value : 0;
    }

    function scrollGuideToTop() {
      const top = guide.getBoundingClientRect().top + window.scrollY - getStickyHeaderOffset() - getAnnouncementOffset();
      window.scrollTo({
        top: Math.max(0, top),
        left: 0,
        behavior: "smooth"
      });
    }

    function updateThresholdModules() {
      thresholdFrame = null;
      updateFloatingTopbar();
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      const triggerLine = viewport * -0.04;

      root.querySelectorAll("[data-sol-threshold-module]").forEach((section) => {
        if (!section.closest(".chapter-content.is-active")) {
          section.classList.remove("is-open");
          return;
        }

        const rect = section.getBoundingClientRect();
        section.classList.toggle("is-open", rect.top <= triggerLine);
      });
    }

    function requestThresholdUpdate() {
      if (thresholdFrame) return;
      thresholdFrame = window.requestAnimationFrame(updateThresholdModules);
    }

    function render(index) {
      currentIndex = (index + titles.length) % titles.length;
      progressText.textContent = `${twoDigit(currentIndex + 1)} / ${twoDigit(titles.length)}`;
      nextLabel.textContent = `Next: ${titles[(currentIndex + 1) % titles.length]}`;

      contentSections.forEach((section) => section.classList.remove("is-active"));

      const activeSection = root.querySelector(`[data-content="${currentIndex}"]`);
      if (activeSection) {
        activeSection.classList.add("is-active");
      } else {
        placeholderTitle.textContent = titles[currentIndex];
        placeholder.classList.add("is-active");
      }

      requestThresholdUpdate();
      window.dispatchEvent(new CustomEvent("solarii:chapter-render", { detail: { index: currentIndex } }));
    }

    function openGuide(index) {
      render(index);
      guide.classList.add("is-content-open");
      cover.classList.add("is-hidden");
      content.classList.add("is-visible");
      content.setAttribute("aria-hidden", "false");
      scrollGuideToTop();
      requestThresholdUpdate();
    }

    root.querySelectorAll(".guide-link").forEach((button) => {
      button.addEventListener("click", () => openGuide(Number(button.dataset.index)));
    });

    root.querySelector("#backToGuide").addEventListener("click", () => {
      content.classList.remove("is-visible");
      content.setAttribute("aria-hidden", "true");
      cover.classList.remove("is-hidden");
      guide.classList.remove("is-content-open", "is-topbar-floating");
      scrollGuideToTop();
    });

    root.querySelector("#prevButton").addEventListener("click", () => {
      render(currentIndex - 1);
      scrollGuideToTop();
    });

    root.querySelector("#nextButton").addEventListener("click", () => {
      render(currentIndex + 1);
      scrollGuideToTop();
    });

    window.addEventListener("scroll", requestThresholdUpdate, { passive: true });
    window.addEventListener("resize", requestThresholdUpdate);
    requestThresholdUpdate();
  }

  function initAllSolariiGuides(container = document) {
    container.querySelectorAll("[data-solarii-guide-host]").forEach(initSolariiGuide);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllSolariiGuides());
  } else {
    initAllSolariiGuides();
  }

  document.addEventListener("shopify:section:load", (event) => initAllSolariiGuides(event.target));
})();
